<div class="wrapper">
    <div class="container px-0">
        <!--<h5 class="main-title fw-bold mb-4">{{patientpersonalinfo?.PracticeName}}</h5>-->
        <div class="px-2 pb-3">
            <div class="form-group">
                <p class="mb-3">{{'PaymentType.title'|translate}}<span class="text-danger">*</span></p>
                <div class="btn-group w-100 ltr-component" id="payment-method" role="group" aria-label="Basic example">

                    <button type="button" class="btn" *ngIf="PracticeCode?.toString() !== '1013906'" [ngClass]="
                  isInsurance 
                    ? (isDrsite ? 'blue-btn' : 'btn-primary') 
                    : (isDrsite ? 'blue-btn-outline' : 'btn-outline-primary')"
                        (click)="UpdatePatientSelfPayBit('insurance')">{{'PaymentType.insurance'|translate}}</button>

                    <!-- Self Pay button: hamesha show hoga -->
                    <button type="button" class="btn" [ngClass]="isSelfPay? (isDrsite ? 'blue-btn' : 'btn-primary') 
                    : (isDrsite ? 'blue-btn-outline' : 'btn-outline-primary')"
                        (click)="UpdatePatientSelfPayBit('selfpay')">{{'PaymentType.selfPay'|translate}}</button>

                </div>
            </div>
        </div>
    </div>
</div>


<footer class="p-3">
    <div class="container p-0">
        <div class="row">
            <div class="col-4">
                <!-- <a class="btn btn-outline-primary" type="button" (click)="backPage()">Back</a> -->
            </div>
            <div class="col-4 text-center">
                <!-- <p class="mb-0">(1 of 3)</p> -->
            </div>
            <div class="col-4 text-right">
                <!-- <a class="btn btn-primary" type="button" (click)="UpdatePatientSelfPayBit()">Next</a> -->
            </div>
        </div>
    </div>
</footer>
